import { authorizeGroupRole, User } from 'features/user'
import { UserGroup } from 'features/user/types/UserGroupRoles'
import { Can } from 'providers/casl'
import { onEmployeesOnly } from './onEmployeesOnly'

export const userByGroup = (user: User, can: Can) => {
  const userBelongsToGroup = (userGroup: UserGroup) => authorizeGroupRole(userGroup, user.role)

  if (userBelongsToGroup('employeesOnly')) {
    onEmployeesOnly(can)
  }
}
